var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifyBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180252",
    "data-name": "Group 180252",
    transform: "translate(-1256.047 -13.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12940",
    "data-name": "Group 12940",
    transform: "translate(32.047 0.949)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_504",
    "data-name": "Ellipse 504",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1224 13)",
    fill: "#f2f3f3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_119",
    "data-name": "Union 119",
    d: "M19728.363,18526.131H19732a1.818,1.818,0,0,1-3.637,0Zm-5.414-.906a.932.932,0,0,1-.664-1.6l1.229-1.205v-5.6a6.554,6.554,0,0,1,5.236-6.375v-1.1a1.432,1.432,0,0,1,2.863,0v1.1a6.554,6.554,0,0,1,5.236,6.375v5.6l1.232,1.205a.935.935,0,0,1-.678,1.6Z",
    transform: "translate(-18458.135 -18488)",
    fill: "#878888"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyBell);
export default __webpack_public_path__ + "static/media/notifyBell.df2f6b50ad820e1ce734f8f5be658da6.svg";
export { ForwardRef as ReactComponent };